import declarationslist from './declarationslist';
import softDelete from './delete';
import getStatus from './getstatus';
import kedu from './kedu';
import signAndSend from './signsend';
import zusConfirmation from './zusconfirmation';

export default {
  signAndSend,
  declarationslist,
  kedu,
  zusConfirmation,
  softDelete,
  getStatus,
};
